import { Box, Skeleton } from "@mui/material";
import React from "react";

export const SkeletonArticulosList = () => {
  return (
    <>
      {Array.from(new Array(5)).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#FFFFFF",
            borderRadius: "4px",
            p: 1,
            margin: 1,
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Skeleton variant="rectangular" width={50} height={50} sx={{ borderRadius: 2, ml: 1.5 }} />
          <Box sx={{ ml: 1, flex: 1 }}>
            <Skeleton variant="text" width="40px" height="15px" />
            <Skeleton variant="text" width="50px" height="15px" sx={{mt:-0.5}} />
            <Skeleton variant="text" width="50px" height="15px" sx={{mt:-0.5}} />
          </Box>
          <Skeleton variant="text" width="40px" sx={{ mr: 1 }} />
          <Skeleton variant="circular" width="20px" sx={{ mr: 0.5 }} />
          <Skeleton variant="rounded" width="20px" sx={{ mr: 0.5 }} />
          <Skeleton variant="circular" width="20px" sx={{ mr: 1 }} />
          <Skeleton variant="rounded" width="20px" sx={{ mr: 2 }} />
        </Box>
      ))}
    </>
  );
};
